import React from 'react'
import { Datagrid, DateField, TextField } from 'react-admin'
import { getGeoLang } from 'services/geo-management'
import { optionsDate } from 'services/utils/date'
import DeleteAndExportBulk from 'ui-shared/BulkActionGroups/DeleteAndExportBulk'
import KFilters from 'ui-shared/KFilters'
import KPagination from 'ui-shared/KPagination'
import KList from 'ui-shared/KWrappers/KList'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { BaseListProps } from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const PmiList: React.FC<BaseListProps> = (props) => {
  return (
    <SectionWrapper>
      <KList
        {...props}
        bulkActionButtons={<DeleteAndExportBulk />}
        pagination={<KPagination />}
        perPage={40}
        exporter={false}
        sort={{ field: 'name', order: 'ASC' }}
        filters={<KFilters />}
      >
        <Datagrid rowClick="edit">
          <TextField source="name" />
          <TextField source="email" sortable={false} />

          <TextField
            source="membership.organizationName"
            label="form.fields.organizationName"
            sortable={false}
          />

          <DateField
            source="createdAt"
            label="Registation Date"
            sortable={false}
            options={optionsDate}
            locales={getGeoLang()}
          />
          <DateField
            source="lastLogin"
            label="Last Login Date"
            options={optionsDate}
            locales={getGeoLang()}
          />
        </Datagrid>
      </KList>
    </SectionWrapper>
  )
}

export default PmiList
